export default {"src":"/_next/static/media/logo-videopeel.1835b57b.svg","height":40,"width":174};